import { GridColDef } from '@mui/x-data-grid';


export const columns: GridColDef[] = [
  { field: 'name', headerName: 'Nombre', flex: 150 },
  { field: 'last_name', headerName: 'Apellido', flex: 150 },
  { field: 'email', headerName: 'Email', flex: 200 },
  { field: 'cellphone', headerName: 'Teléfono', flex: 150 },
  { field: 'created_date', headerName: 'Fecha de Creación', flex: 150 },
]

export const handleDoubleClickRow = (event: any, setPersonId: any) => {
  setPersonId(event.row.id)
}
